import { computed } from "vue";

import { useAccountViewState } from "./useAccountViewState";
import { useDropdownItems } from "@/composables/dropdown/useDropdownItems";

export function useTableConfig() {
  const viewState = useAccountViewState();
  const dropdownItems = useDropdownItems();
  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "User / Employee",
          sortable: true,
          value: "user",
          width: "100%",
        },
        {
          text: "Account",
          sortable: false,
          value: "",
        },
        {
          text: "Admin Permissions",
          sortable: false,
          value: "",
        },
        {
          text: "Last Seen",
          sortable: false,
          value: "",
        },
        {
          text: "Access Status",
          sortable: false,
          value: "",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
        },
      ],
      columns: [
        {
          field: "",
          component: "UserCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getUsersProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "UserCard2",
          props: (item) => ({
            class: "my-4",
            ...viewState.getAccountOwnerProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "AdminAccessPermissionBadges",
          props: (item) => ({
            class: "my-4",
            chips: Array.isArray(item.accessChip) ? item.accessChip : [],
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "AdminAccessLastSeen",
          props: (item) => ({
            class: "my-4",
            text: item.last_logged_in_at || "",
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "UserStatusBadge",
          props: (item) => ({
            class: "my-4",
            ...viewState.getUserStatusBadgeProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "Dropdown",
          props: (item) => ({
            "data-testid": "employee-operations-menu",
            translateXOffset: 3,
            translateYOffset: 2,
            isOpen: false,
            scrollContainerClass: ".ex-main-container",
            attachSelector: ".ex-main-container",
            absolute: true,
            dropdownItems: dropdownItems.getAdminAccountUsersItems(item),
          }),
          events: () => ({
            onClick: (operation) => {
              viewState.handleAccountUserDropdownOperation(operation);
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
        searchGhostText: "Search",
      },
      hideTopSection: true,
      hideActiveNo: true,
      activeRecords: {
        field: "",
        value: "  ",
      },
      hideButtonInMessage: true,
      actionLabel: "Add Account",
      hideGridView: true,
      hideFilterBtn: true,
      showActionButton: viewState.state.filters.needsRecalculation ? false : true,
      title: "",
      getRowStyle: (item) => ({
        backgroundColor: item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
